import React, {
  ReactElement,
  ReactNode,
  memo,
} from 'react';
import './index.scss';
import CardSlot from '@/pages/dashboard/components/CardSlot';
import CompaniesTable from '../CompaniesTable';
import { useIntl } from 'umi';
type IDataList<T = string> = Array<{
  id: T;
  text: T;
  data: T | any;
}>;
interface DropChildProps {
  title: string | ReactNode;
  dataList: IDataList;
  tableData: any;
  children: ReactNode;
  id?: string;
  className: string;
  loading: boolean;
  total: number,
  pageIndex: number,
  pageSize: number,
  onPagingChange: (...args: any) => void,
  OnClickTableSort: (...args: any) => void,
}
const CardCont = memo((props: Partial<DropChildProps>): ReactElement => {
  const {
    title,
    dataList,
    tableData,
    children,
    id,
    className,
    loading,
    total = 0,
    pageIndex = 1,
    pageSize = 10,
    onPagingChange,
    OnClickTableSort,
  } = props;
  const { formatMessage } = useIntl();
  return (
    <div className="dbi-financials-rcont-block" id={id} >
      <CardSlot className="dbi-cardcont" title={title} iconShow>
        <div className="cardcont-list" >
          {dataList?.map((e) => (
            <div key={e.id} className="cardcont-list-item">
              <div className="cardcont-list-item-inner">
                <div className="cardcont-list-item-text">
                  {formatMessage?.({ id: e.text })}
                </div>
                <div className="cardcont-list-item-data">
                  {e.data}
                </div>
              </div>
            </div>
          ))}
        </div>
        {tableData ?
          (
            <CompaniesTable
              {
              ...{
                className,
                total,
                pageIndex,
                pageSize,
                onPagingChange,
                OnClickTableSort,
                loading,
                tableData: {
                  cvmList: tableData?.cvmList,
                  columns: tableData?.columns,
                  addonscolumns: tableData?.addonscolumns
                }
              }
              }
            />
          )
          : (
            children
          )}
      </CardSlot>
    </div>
  );
}
)

export default CardCont;
